import { ofType } from "redux-observable";
import { map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { TypeActionAuth } from "../../../auth/actionAuth";
import { actionPlayerSettingsInfo } from "../actionPlayerSettingsInfo";
export var epicPlayerSettingsInfo = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionAuth.Login), switchMap(function (action) {
        return deps.netSend({
            id: CommandCode.PlayerSettingsInfo,
            props: {
                playerId: action.playerId,
            },
        });
    }), retry(), map(function (res) { return actionPlayerSettingsInfo(res); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/player-settings/epics/epicPlayerSettingsInfo.ts
// module id = 1927
// module chunks = 3